module.exports = __webpack_public_path__ + "static/wordpress-5c4698f3f1f97988875cd4c1f0adad47.png";